<script setup lang="ts">
import { TabsRoot } from 'radix-vue'
import { provide, computed } from 'vue'

defineProps<{
  defaultValue: string
}>()
const variant = defineModel<string>('variant', { default: 'line' })

// Centralize all variant styles
const variantStyles = computed(() => ({
  line: {
    list: 'flex items-center justify-start border-b border-gray-200 dark:border-gray-800',
    trigger: [
      '-mb-px items-center justify-center whitespace-nowrap border-b-2 border-transparent px-3 pb-2 text-sm font-medium transition-all',
      'text-gray-500 dark:text-gray-500',
      'hover:text-gray-700 hover:dark:text-gray-400',
      'hover:border-gray-300 hover:dark:border-gray-400',
      'data-[state=active]:border-blue-500 data-[state=active]:text-blue-500',
      'data-[state=active]:dark:border-blue-500 data-[state=active]:dark:text-blue-500',
      'data-[disabled]:pointer-events-none data-[disabled]:text-gray-300 data-[disabled]:dark:text-gray-700',
    ],
  },
  solid: {
    list: 'inline-flex items-center justify-center rounded-md p-1 bg-gray-100 dark:bg-gray-900',
    trigger: [
      'inline-flex items-center justify-center whitespace-nowrap rounded px-3 py-1 text-sm font-medium ring-1 ring-inset transition-all',
      'text-gray-500 dark:text-gray-400',
      'hover:text-gray-700 hover:dark:text-gray-200',
      'ring-transparent',
      'data-[state=active]:bg-white data-[state=active]:text-gray-900 data-[state=active]:shadow',
      'data-[state=active]:dark:bg-gray-800 data-[state=active]:dark:text-gray-50',
      'data-[disabled]:pointer-events-none data-[disabled]:text-gray-400 data-[disabled]:opacity-50 data-[disabled]:dark:text-gray-600',
    ],
  },
}))

// Provide both variant and styles to child components
provide('tabs-variant', variant)
provide('tabs-styles', variantStyles)
</script>

<template>
  <TabsRoot :default-value="defaultValue">
    <slot />
  </TabsRoot>
</template>
